// eslint-disable-next-line import/prefer-default-export
export const checkAndReturnIfNull = (hitProperty: unknown, nullObject: null | [] | boolean) => {
  if (Array.isArray(hitProperty) && !hitProperty.length) return nullObject;
  if (!hitProperty) return nullObject;
  return hitProperty;
};